export const documentAccept = "image/*, application/pdf, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, " +
    "application/vnd.ms-excel, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document, application/rtf";

export const pdfAccept = "application/pdf";

export const excelAccept = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"